import React, { Fragment, useState, useRef, useEffect } from "react";
import { colors, getBreakPoint, UI_BODY_SEMIBOLD_SM_DF, useScreenWidth } from 'oolib'
//actions
import {
  __CheckAccessToPrivatePlatform
} from "../../../../../utils/accessControl";
import { icons } from 'oolib'

//config
import {
  useGetQueryData,
  useGetQueryState
} from "../../../../../utils/react-query-hooks/general";

// import { logout } from "../../../actions/auth";
//KP components

import { HeaderLogo } from "./comps/HeaderLogo";
import { HeaderPublishButton } from "./comps/HeaderPublishButton";

import HamburgerMenuV2 from "../../HamburgerMenuV2";
import { AuthLinks } from "./comps/AuthLinks";
import { AuthLinksLoader } from "./comps/AuthLinks/AuthLinksLoader";
import { GuestLinks } from "./comps/GuestLinks";
import { DividerVertical, HeaderLanguageSelect } from "./comps/HeaderLanguageSelect";
import { PRIMLinksGenerator } from "./PRIMLinksGenerator";
import { SECNavbar } from "./SECNavbar";
import { useSearchParamsState } from "../../../../../utils/customHooks";
import { OKF_HEADER_ZINDEX, useHeaderHeight } from "@/CONSTANTS";
import MyNotifications from "./comps/MyNotifications";
import { 
  StyledHamburgerButton, 
  StyledHeaderContent, 
  StyledHeaderLeft, 
  StyledHeaderNavLinksWrapper, 
  StyledHeaderRight, 
  StyledOKFHeader, 
  StyledOKFHeader1 } from "../styled";
import { pluginConfigs } from "../../../../../Plugins/_EXPORTS";
import { getTenant } from "../../../../../TENANT_CONFIGS";
import { HeaderBreakpoint } from "@/CONSTANTS/hooks/useHeaderHeight";
import { useNavLayout } from "./utils/useNavLayout";
import GlobalSearchButton from "./comps/GlobalSearch";

const { List } = icons;


const HeaderUI = ({ builderProps, config, showBorderBottom = true }) => {
  const screenWidth = useScreenWidth();
  const { _Nav } = config;
  const { status: loadUserStatus, data: userData } = useGetQueryState("userData");
  const [hamburgerOpen, setHamburgerOpen] = useSearchParamsState({
    key: "menu",
    value: false
  });

  const {SELF_MANAGED_BASE_CONFIGS} = useGetQueryData('platformConfigs')
  const headerHeight = useHeaderHeight();

  const tenant = getTenant();
  const headerPopupPlugin = pluginConfigs[tenant]?.HeaderUI?.headerPopupPlugin;
  const { Component: HeaderPopupComponent } = headerPopupPlugin ? headerPopupPlugin() : { Component: null };

  const isLargeScreen = screenWidth > getBreakPoint(HeaderBreakpoint);
  const isSmallScreen = screenWidth < getBreakPoint(HeaderBreakpoint);
  const isUserLoading = loadUserStatus === 'loading';
  const hasPrivateAccess = __CheckAccessToPrivatePlatform(userData?.user);

  const {
      deployment: { _EnableNotifications, _EnableGlobalSearch },
  } = useGetQueryData("platformConfigs");
  
  const { headerRef, logoRef, navRef, rightRef, navLayout } = useNavLayout(_Nav, isLargeScreen, hasPrivateAccess, isUserLoading);

  const renderAuthSection = () => {
    if (builderProps?.guest_authLinks === "guest") return <GuestLinks isSmallScreen={isSmallScreen} />;
    if (builderProps && builderProps.guest_authLinks !== "guest") return <AuthLinks />;
    
    if (isUserLoading) return <AuthLinksLoader />;
    if (loadUserStatus === 'error') return <GuestLinks isSmallScreen={isSmallScreen} />;
    if (loadUserStatus === 'success') return <AuthLinks />;
    
    return null;
  };

  return (
    <StyledOKFHeader className="OKE-Header" style={{ zIndex: OKF_HEADER_ZINDEX, background: colors.white }} ref={headerRef} showBorderBottom={showBorderBottom}>
      <StyledOKFHeader1 className="OKE-Header1" style={{ height: headerHeight }}>
        <StyledHeaderContent className="OKE-Header1-content" isSmallScreen={isSmallScreen}> {/* This className is important for platformBuilder highlight to work*/}
          
          <StyledHeaderLeft className="OKE-Header1__module1" isSmallScreen={isSmallScreen}>
            <div style={{ display: "flex", alignItems: "center", height: "100%", flexGrow: 1 }}>
              {/* logo */}
              <div ref={logoRef} style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <HeaderLogo config={config} />
              </div>
              {/* hamburgermenu */} 
              {!isLargeScreen && !isUserLoading && (
                <Fragment>
                  <StyledHamburgerButton id={"oke_Header_hamburgerButton"} onClick={() => setHamburgerOpen(!hamburgerOpen)}>  {/* Id required of Coachmarks */}
                    <List size={20} />
                    <UI_BODY_SEMIBOLD_SM_DF>Menu</UI_BODY_SEMIBOLD_SM_DF>
                  </StyledHamburgerButton>

                  <HamburgerMenuV2
                    builderProps={builderProps}
                    _Nav={_Nav}
                    hamburgerOpen={hamburgerOpen}
                    setHamburgerOpen={setHamburgerOpen}
                  />
                </Fragment>
              )}
            </div>
            {/* notifications on Small screens*/}
              {(_EnableNotifications && loadUserStatus === 'success' && isSmallScreen ) &&    
                ( <MyNotifications isSmallScreen={isSmallScreen} /> )
              }
            {/* prim links */}
            {(hasPrivateAccess && isLargeScreen)&&  (
              <StyledHeaderNavLinksWrapper className="OKE-Header1__module2" ref={navRef}>
                {!isUserLoading && isLargeScreen && ( //wait for a verdict on userData, cuz PRIMLinks uses it for accesscontrol
                  <PRIMLinksGenerator 
                    builderProps={builderProps} 
                    _Nav={_Nav} 
                    useFixedWidth={navLayout.isOverflowing}
                    maxWidth={navLayout.itemWidth}
                  />
                )}
              </StyledHeaderNavLinksWrapper>
            )}

          </StyledHeaderLeft>

          <StyledHeaderRight className="OKE-Header1__module2" ref={rightRef}> 
            {_EnableGlobalSearch?.enable ? (
              <>
                <GlobalSearchButton isSmallScreen={isSmallScreen} />
                {isLargeScreen && <DividerVertical />}
              </>
            ) : null}
            {/* notifications on LG screens*/}
            {(_EnableNotifications && loadUserStatus === 'success' && isLargeScreen ) &&    
              (<><MyNotifications isSmallScreen={isSmallScreen}/> <DividerVertical/></>)
            }
            
            {/* Language select LG screen */}
            <HeaderLanguageSelect />

            <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", height: "100%" }}>
              {/* Auth section - login || user profile link button */}
              {isLargeScreen || !userData ? renderAuthSection() : null}
              
              {/* CTA */}
              {SELF_MANAGED_BASE_CONFIGS?.enableHeaderPublishButton === false
              ? null
              : (isSmallScreen && userData) || (!isSmallScreen) ? 
                <HeaderPublishButton 
                  isSmallScreen={isSmallScreen} 
                  config={config} 
              /> : null}
            </div>
            
          </StyledHeaderRight>

        </StyledHeaderContent>
      </StyledOKFHeader1>
      
      {_Nav.secondary && hasPrivateAccess && !isUserLoading && ( //wait for a verdict on userData, cuz SECbar uses it for accesscontrol
        <SECNavbar 
          _Nav={_Nav} 
          builderProps={builderProps}
        />
      )}
      {HeaderPopupComponent}
    </StyledOKFHeader>
  );
};
export default HeaderUI;

